import * as React from 'react';
import { message } from 'antd';
import * as intl from "react-intl-universal";

interface iOptions {
    locale?: {
        copySucceeded?: string;
        copyFailed?: string;
    };
}

export default (options: iOptions = {}) =>
    (WrappedComponent: React.ComponentClass<any>): any =>
        class Clipboard extends React.Component {
            private locale = options.locale || {
                copySucceeded: intl.get('Hint.CopySucceeded'),
                copyFailed: intl.get('Hint.CopyFailed')
            };

            private isIOS = navigator.userAgent.match(/iphone|ipod|ipad|ios/i);

            private copy = (text: string) => {
                const node = document.createElement('textarea');
                document.body.appendChild(node);
                node.value = text;
                node.textContent = text;
                if (this.isIOS) {
                    const selection = getSelection();
                    const range = document.createRange();
                    range.selectNode(node);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    node.setSelectionRange(0, 999999);
                } else {
                    node.select();
                }
                // exec copy command
                document.execCommand('copy')
                    ? message.success(this.locale.copySucceeded)
                    : message.error(this.locale.copyFailed);
                // destroy the element
                document.body.removeChild(node);
            };

            render() {
                const clipboard = {
                    copy: this.copy
                };
                return (
                    <WrappedComponent {...this.props} clipboard={clipboard} />
                );
            }
        };

export const ClipboardFn = (options: iOptions = {}) =>
    (WrappedComponent: (clipboard: (text: string) => void) => void) => {
        const locale = options.locale || {
            copySucceeded: intl.get('Hint.CopySucceeded'),
            copyFailed: intl.get('Hint.CopyFailed')
        };

        const isIOS = navigator.userAgent.match(/iphone|ipod|ipad|ios/i);

        const copy = (text: string) => {
            const node = document.createElement('textarea');
            document.body.appendChild(node);
            node.value = text;
            node.textContent = text;
            if (isIOS) {
                const selection = getSelection();
                const range = document.createRange();
                range.selectNode(node);
                selection.removeAllRanges();
                selection.addRange(range);
                node.setSelectionRange(0, 999999);
            } else {
                node.select();
            }
            // exec copy command
            document.execCommand('copy')
                ? message.success(locale.copySucceeded)
                : message.error(locale.copyFailed);
            // destroy the element
            document.body.removeChild(node);
        };

        const clipboard = { copy };

        return WrappedComponent(clipboard.copy);
    };
